import { render } from "./YUpload.vue?vue&type=template&id=43a1575d&scoped=true"
import script from "./YUpload.vue?vue&type=script&lang=js"
export * from "./YUpload.vue?vue&type=script&lang=js"

import "./YUpload.vue?vue&type=style&index=0&id=43a1575d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a1575d"]])

export default __exports__